import { DateTime, Duration } from 'luxon'
import { RRule } from 'rrule'
import memoize from './memoize.utils'
import { ActiveFeature } from '../types/lot.interface'

const getNightParkingConfig = (feature: ActiveFeature): { rrule: string; iso_duration: string } => {
    if (!feature) {
        return { rrule: '', iso_duration: '' }
    }
    if (feature.config.night_parking_times) {
        if (feature.config.night_parking_times.length === 1) {
            return feature.config.night_parking_times[0]
        }

        // else return the one that include 'mo, tu' in rrule
        const feat = feature.config.night_parking_times.find((npt) => npt.rrule.includes('MO,TU,WE,TH,FR'))
        if (feat) {
            return feat
        }
    }

    if (feature.config.rrule && feature.config.iso_duration) {
        return { rrule: feature.config.rrule, iso_duration: feature.config.iso_duration }
    }

    return { rrule: '', iso_duration: '' }
}

export const getNightParkingTimesFromConfig = (nightFeature: ActiveFeature): { start: string; end: string } => {
    const { rrule, iso_duration } = getNightParkingConfig(nightFeature)
    const rule = RRule.fromString(rrule)
    const now = new Date()
    const nextOccurrenceStart = rule.after(now) ?? now
    const startDateTime = DateTime.fromJSDate(nextOccurrenceStart, { zone: 'UTC' })

    // Parse the duration using Luxon
    const dur = Duration.fromISO(iso_duration)

    // Calculate the end datetime by adding the duration to the start datetime
    const endDateTime = startDateTime.plus(dur)

    return {
        start: startDateTime.toFormat('HH:mm'),
        end: endDateTime.toFormat('HH:mm')
    }
}

export const getNightParkingTimesFromConfigMemoized = memoize(getNightParkingTimesFromConfig)
